import { useMemo } from "react";
import { VehicleTripSegment } from "../../models/vehicle/vehicleTripSegment";
import { Position } from "../../components/framework/map/map";
import { useAppSelector } from "../../framework/customStore";

export const useVehicleRouteMapData = (vehicleRoute: VehicleTripSegment[]) => {
    const selectedVehicleId = useAppSelector((state) => state.monitorView.selectedVehicleId);
    const selectedRouteId = useAppSelector((state) => state.monitorView.selectedRouteId);
    const hoveredRouteId = useAppSelector((state) => state.monitorView.hoveredRouteId);

    const routes = useMemo(() => {
        return vehicleRoute?.map((segment, index) => {
            const uniqueId = `${selectedVehicleId}-${index}`; // Ensure IDs match the logic in VehicleRouteList
            const isHighlighted = uniqueId === selectedRouteId || uniqueId === hoveredRouteId;

            const coords: Position[] = segment.positions.map((position) => ({
                lat: position.latitude,
                lng: position.longitude,
            }));

            return {
                coords,
                highlight: isHighlighted,
            };
        });
    }, [vehicleRoute, selectedRouteId, hoveredRouteId]);

    const points = useMemo(() => {
        return vehicleRoute
            ?.filter((segment) => segment.state === "Stopped")
            .map((segment, index) => ({
                segment,
                position: segment.positions[0],
                stopNumber: index + 1
            }))
            .map(({ segment, position, stopNumber }) => ({
                id: `${position.vehicleId}-${position.timestamp}`,
                coords: { lat: position.latitude, lng: position.longitude },
                text: `# ${stopNumber}`,
                fullText: [
                    `# ${stopNumber}`,
                    segment?.streetAddress

                ]
                    .filter(Boolean)
                    .join(" - "),
                textColorClass: "white",
                textBgColorClass: "blue-light",
                groupColor: "#426ac6",
                groupName: "stopped",
            }));
    }, [vehicleRoute]);

    return { routes, points };
};